import { Dayjs } from 'dayjs'
import { useTranslation } from 'react-i18next'
import TimePicker from '@/shared/components/TimePicker/TimePicker'
import { useScheduleStore } from '../../store/useScheduleStore'
import { NightWindow } from '../../utils/payroll'
import {
  TIME_STEP_MINUTES,
  dayjsToMinutes,
  minutesToDayjs
} from '../../utils/schedule'
import styles from './NightWindowFields.module.scss'

/**
 * The venue's night hours, which the payroll view's NIGHT column counts. In
 * that view's toolbar, as the calendar's mode is in its own: one setting of
 * the view, not a row above the table.
 */
function NightWindowFields() {
  const { t } = useTranslation()
  const nightWindow = useScheduleStore(state => state.nightWindow)
  const setNightWindow = useScheduleStore(state => state.setNightWindow)

  const setTime = (key: keyof NightWindow) => (value: Dayjs | null) => {
    const minutes = dayjsToMinutes(value)
    if (minutes !== null) setNightWindow({ ...nightWindow, [key]: minutes })
  }

  return (
    <div className={styles.fields}>
      <TimePicker
        label={t('PAYROLL.NIGHT_FROM')}
        value={minutesToDayjs(nightWindow.startMinutes)}
        onChange={setTime('startMinutes')}
        minutesStep={TIME_STEP_MINUTES}
        pinnedLabel
      />
      <TimePicker
        label={t('PAYROLL.NIGHT_TO')}
        value={minutesToDayjs(nightWindow.endMinutes)}
        onChange={setTime('endMinutes')}
        minutesStep={TIME_STEP_MINUTES}
        pinnedLabel
      />
    </div>
  )
}

export default NightWindowFields
